/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgBeaconExit = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="m5.311 6.638 1.377 1.409c-1.712 1.58-2.667 3.7-2.688 5.97-.022 2.334.938 4.549 2.701 6.235l-1.403 1.386C3.145 19.578 1.974 16.864 2 14c.026-2.8 1.202-5.416 3.311-7.362zm13.378 0C20.798 8.584 21.974 11.2 22 14c.026 2.864-1.145 5.577-3.298 7.638l-1.403-1.386c1.763-1.686 2.723-3.9 2.701-6.235-.021-2.27-.976-4.39-2.688-5.97zM7.282 8.608l1.434 1.355c-2.289 2.289-2.287 6.043.005 8.367l-1.444 1.344c-3.028-3.07-3.026-8.036.005-11.066zm9.436 0c3.03 3.03 3.033 7.995.005 11.066l-1.444-1.344c2.292-2.324 2.294-6.078.005-8.367zM12 11c1.654 0 3 1.308 3 2.915s-1.346 2.915-3 2.915-3-1.308-3-2.915S10.346 11 12 11zm0 1.943c-.552 0-1 .436-1 .972s.448.972 1 .972 1-.436 1-.972-.448-.972-1-.972zm1.677-10.802L15 3.464l-1.678 1.677L15 6.82l-1.323 1.32L12 6.463l-1.677 1.678L9 6.82l1.677-1.678L9 3.464l1.323-1.323L12 3.818z"
      fill="currentcolor"
      fillRule="evenodd"
    />
  </Icon>
);
export { SvgBeaconExit as BeaconExit };
